export default __webpack_public_path__ + "static/media/Reyna_artwork.493f17e5.png";